<switch name="basicSwitch" [(ngModel)]="value"></switch>